module.exports = __webpack_public_path__ + "img/manage.de43fc60.svg";